export default {
  name: {
    id: 'rm_metal_strontium_name',
    defaultMessage: 'Strontium',
  },
  smartphoneLabel: {
    id: 'rm_metal_strontium_smartphone_label',
    defaultMessage: 'Trace (invisible to the naked eye)',
  },
  whatItDoesText: {
    id: 'rm_metal_strontium_what_it_does',
    defaultMessage:
      'Strontium compounds may be used in display glass to improve durability and hardness. They are also used to produce strontium titanate for advanced capacitors and thin-film electronic applications.',
  },
  extractionText1: {
    id: 'rm_metal_strontium_extraction_p1',
    defaultMessage:
      'Strontium is not mined as a pure metal. It comes mainly from celestite (SrSO₄), and less often from strontianite (SrCO₃). Celestite is crushed, screened and concentrated by methods including gravity separation, dense-media separation and flotation, producing a concentrate containing more than 90% SrSO₄. The concentrate can then be refined into strontium carbonate and other compounds.',
  },
  quickFactText: {
    id: 'rm_metal_strontium_quick_fact',
    defaultMessage:
      'Strontium supply is highly concentrated: Spain, Iran and China accounted for nearly 95% of global celestite mine production in 2024.',
  },
  envSummaryText: {
    id: 'rm_metal_strontium_env_summary',
    defaultMessage:
      'Strontium mining and processing consume diesel, electricity and water and generate waste. Transport can also be a major part of the environmental footprint, particularly when concentrates are moved between distant mining and processing sites.',
  },
  envWaterText: {
    id: 'rm_metal_strontium_env_water_text',
    defaultMessage:
      'Mining and processing can consume water and generate wastewater and mineral residues. Strontium is highly soluble, and elevated concentrations in water can result from human activities. Strontium chromate, a specific strontium compound, is classified as very toxic to aquatic life with long-lasting effects.',
  },
  humanSummaryText: {
    id: 'rm_metal_strontium_human_summary',
    defaultMessage:
      'The sources identify no specific social or ethical concerns at the mining stage. However, workers may face general risks associated with mining and mineral processing, including dust, machinery, accidents and exposure to chemical residues. While stable strontium is generally considered safe at low concentrations, some strontium compounds and isotopes are hazardous. Strontium chromate is carcinogenic and harmful if swallowed, while the radioactive isotope strontium-90 can cause bone disorders and bone cancer if ingested through contaminated food or water.',
  },
  humanHealthText: {
    id: 'rm_metal_strontium_human_health_text',
    defaultMessage:
      'Strontium chromate is listed under the European Union’s chemical-safety system as a substance requiring authorisation because it is carcinogenic. It is also classified as harmful if swallowed. Canada has proposed a maximum acceptable concentration of 7 mg/L for strontium in drinking water.',
  },
  geoSummaryText: {
    id: 'rm_metal_strontium_geo_summary',
    defaultMessage:
      'Strontium production is concentrated among a few countries, while the material is used in magnets, glass, ceramics, electronics and pyrotechnics. Spain, Iran, China and Mexico are the main producers. Spain supplies approximately 99% of the European Union’s strontium supply.',
  },
  geoDugText: {
    id: 'rm_metal_strontium_geo_dug_text',
    defaultMessage:
      'Celestite, the main ore of strontium, is mined mainly in Spain and Iran, which each accounted for approximately 39% of the rounded global total in 2024. China accounted for around 16%, followed by Mexico at approximately 5%. Spain, Iran and China together accounted for nearly 95% of global celestite production. These figures refer to the gross weight of celestite ore, not strontium content or strontium metal.',
  },
  geoProcessedText: {
    id: 'rm_metal_strontium_geo_processed_text',
    defaultMessage:
      'Celestite is processed in producing countries such as Iran, Spain and China into high-grade strontium sulfate concentrate, strontium carbonate and other compounds.',
  },
  geoLeverageText: {
    id: 'rm_metal_strontium_geo_leverage_text',
    defaultMessage:
      'Because only a few countries produce strontium, disruptions in Spain, Iran, China or Mexico could affect prices and availability. Spain’s near-dominant position in EU supply gives it particular importance for European users. Prices have also shown sharp increases during periods of supply disruption, rising to a record level in 2024.',
  },
  supplySummaryText: {
    id: 'rm_metal_strontium_supply_summary',
    defaultMessage:
      'Strontium supply may be vulnerable to disruption because production is concentrated among a small number of countries. The global strontium market is projected to grow by approximately 4.8% per year between 2024 and 2032. Recent price volatility and limited producer diversity could increase supply risks for strontium-based industries.',
  },
  supplyReservesText: {
    id: 'rm_metal_strontium_supply_reserves_text',
    defaultMessage: 'No complete global reserve estimate is provided.',
  },
  supplyDemandText: {
    id: 'rm_metal_strontium_supply_demand_text',
    defaultMessage:
      'The global strontium market is projected to grow by approximately 4.8% per year between 2024 and 2032. Strontium-based ferrite magnets are a lower-cost alternative to many rare-earth permanent magnets and are used in small motors, loudspeakers, electronics and toys. They represented approximately 26.3% of reported European Union strontium use in 2020. Other applications, including glass and semiconductor manufacturing, accounted for approximately 3% of reported European Union strontium use in the same year.',
  },
  recyclingSummaryText: {
    id: 'rm_metal_strontium_recycling_summary',
    defaultMessage:
      'Strontium recycling is very limited, with an estimated global recycling rate below 1%. Some manufacturing residues from strontium ferrite production can be reprocessed. Recovery from old cathode-ray tube glass is more difficult because lead must be separated and the material decontaminated.',
  },
  recyclingInputText: {
    id: 'rm_metal_strontium_recycling_input_text',
    defaultMessage:
      'The European Union’s end-of-life recycling input rate for strontium is estimated at 0%. No reliable figure is available for recycled strontium in new products or for strontium recovered from smartphones.',
  },
  recyclingOutlookText: {
    id: 'rm_metal_strontium_recycling_outlook_text',
    defaultMessage: 'Not currently.',
  },
  footnote1Text1: {
    id: 'rm_metal_strontium_footnote_1_p1',
    defaultMessage:
      'As Strontium is not covered by the ADEME 2024 study, its environmental, social, geopolitical and supply-risk scores were calculated by Back Market’s Sustainability team using ADEME’s methodology, public sources and AI assistance. These scores carry greater uncertainty. See the Sources tab for the full methodology and references.',
  },
} as const
